import React from "react";
import Toolbar from "./Toolbar";
import Bets from "./Bets";
import GameView from "./GameView";
import BetControls from "./BetControls";
import Chat from "./Chat";
import History from "./History";

import Notifications from "./Notifications";

import "./App.css";
import { EVENTS } from "./core/EVENTS";

export default class App extends React.Component<App.Props, App.State>
{

    scrollLock: number;

    constructor(props: App.Props)
    {
        super(props);

        this.state = {
            windows: [],
            chat: window.innerWidth > 767 && window.innerWidth < 992 || window.innerWidth >= 1300
        };

        window.app = this;

        this.onKeyDown = this.onKeyDown.bind(this);
    }


    componentDidMount()
    {
        document.addEventListener("keydown", this.onKeyDown);
    }


    componentWillUnmount()
    {
        document.removeEventListener("keydown", this.onKeyDown);
    }

    componentDidUpdate()
    {
        window.dispatchEvent(new Event("resize"));
        EVENTS.emit(EVENTS.PIXI.RESIZE);
    }


    onKeyDown(e: KeyboardEvent)
    {
        if (e.key == "Escape")
        {
            this.closeLastWindow();
        }
    }


    openChat()
    {
        this.setState({
            chat: true
        });
    }


    closeChat()
    {
        this.setState({
            chat: false
        });
    }


    addWindow(window: JSX.Element)
    {
        this.state.windows.push(window);
        this.setState({
            windows: this.state.windows
        });

        this.scrollLock = document.scrollingElement.scrollTop;
        document.body.style.top = (-this.scrollLock) + "px"
        document.body.style.position = "fixed";
        
        document.documentElement.style.overflow = "hidden";
    }


    closeLastWindow()
    {
        this.state.windows.pop();
        this.setState({
            windows: this.state.windows
        });

        if (this.state.windows.length == 0)
        {
            document.documentElement.style.removeProperty("overflow");
            document.scrollingElement.scrollTop = this.scrollLock;
            
            document.body.style.removeProperty("position");
            document.body.style.removeProperty("top");
        }
    }


    render()
    {

        return (


            <div id="app_wrapper">
                <div
                    id="app"
                    className={"app " + (this.state.chat ? "chat_open" : "") + " " +
                        (this.state.windows.length > 0 ? "window_open" : "")}
                >
                    <div
                        id="main"
                        className="main"
                    >
                        <div className="toolbar"></div>

                        <div
                            className="content_wrapper"
                        >
                            <div
                                id="content"
                            >
                                <Bets />
                                <div
                                    id="game_wrapper"
                                >
                                    <History />
                                    <GameView />
                                    <BetControls />
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="chat"></div>
                </div>

                <div
                    className={"app over " + (this.state.chat ? "chat_open" : "") + " " +
                        (this.state.windows.length > 0 ? "window_open" : "")}
                >
                    <div className="main">
                        <Toolbar />

                        <div className="content_wrapper"></div>
                    </div>
                    <Chat />
                </div>

                <div id="windows">
                    <div className="wrapper">
                        {this.state.windows.map((window, index) => (
                            <React.Fragment key={index}>
                                {window}
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                <Notifications />
            </div>
        );
    }


}

export namespace App
{
    export interface Props
    {

    }

    export interface State
    {
        windows: Array<JSX.Element>;
        chat: boolean;
    }

}